import { motion } from "framer-motion";

/**
 * CinematicTransition — 2–3 second curtain rise between Idle Welcome and In-Game.
 * Step 5: simple, crisp fade + scale. Step 7 will replace this with a
 * full cinematic sequence (particles dissolve, dramatic curtain, sparkle burst).
 */
export default function CinematicTransition() {
  return (
    <div
      data-testid="projector-cinematic-transition"
      className="fixed inset-0 w-screen h-screen flex items-center justify-center"
      style={{ background: "var(--ic-bg-darkest)" }}
    >
      <motion.div
        aria-hidden
        initial={{ scale: 0, opacity: 0.9 }}
        animate={{ scale: 6, opacity: 0 }}
        transition={{ duration: 2.2, ease: "easeOut" }}
        className="absolute rounded-full"
        style={{
          width: 320,
          height: 320,
          background:
            "radial-gradient(circle, var(--ic-primary-glow) 0%, transparent 70%)",
          filter: "blur(20px)",
        }}
      />
      <motion.div
        initial={{ opacity: 0, letterSpacing: "0.6em" }}
        animate={{ opacity: [0, 1, 1, 0], letterSpacing: "0.3em" }}
        transition={{ duration: 2.5, ease: "easeInOut" }}
        className="ic-font-display font-bold tracking-widest uppercase"
        style={{
          fontSize: "clamp(2rem, 5vw, 5rem)",
          color: "var(--ic-text-primary)",
          textShadow: "0 0 40px var(--ic-primary-glow)",
        }}
      >
        Ready...
      </motion.div>
    </div>
  );
}
